import React from 'react';
import Select from 'react-select';

import './index.css';

const LeadsFilters = ({ filters, onChange, onApply, onClear, onSearchChange }) => {
  const handleSelect = (key) => (opt) => onChange({ [key]: opt ? opt['value'] : '' });
  const handleCheck = (key) => (e) => onChange({ [key]: e['target']['checked'] });

  return (
    <div className="leads-filters-panel">
      <div className="leads-filters-title">Filters</div>

      <div className="leads-filters-field">
        <span className="leads-filters-label">Keyword</span>
        <input
          className="leads-filters-search-input"
          type="text"
          placeholder="Name, title, company…"
          value={filters['q'] || ''}
          onChange={onSearchChange}
        />
      </div>

      <div className="leads-filters-field">
        <span className="leads-filters-label">Industry</span>
        <Select
          isClearable
          placeholder="Any industry"
          value={filters['industry'] ? { value: filters['industry'], label: filters['industry'] } : null}
          onChange={handleSelect('industry')}
          options={INDUSTRY_OPTIONS}
          classNamePrefix="react-select"
        />
      </div>

      <div className="leads-filters-field">
        <span className="leads-filters-label">Country</span>
        <Select
          isClearable
          placeholder="Any country"
          value={filters['country'] ? { value: filters['country'], label: filters['country'] } : null}
          onChange={handleSelect('country')}
          options={COUNTRY_OPTIONS}
          classNamePrefix="react-select"
        />
      </div>

      <div className="leads-filters-field">
        <span className="leads-filters-label">Department</span>
        <Select
          isClearable
          placeholder="Any department"
          value={filters['department'] ? { value: filters['department'], label: filters['department'] } : null}
          onChange={handleSelect('department')}
          options={DEPARTMENT_OPTIONS}
          classNamePrefix="react-select"
        />
      </div>

      <div className="leads-filters-field">
        <span className="leads-filters-label">Company Size</span>
        <Select
          isClearable
          placeholder="Any size"
          value={filters['employeeCount'] ? { value: filters['employeeCount'], label: filters['employeeCount'] } : null}
          onChange={handleSelect('employeeCount')}
          options={EMPLOYEE_COUNT_OPTIONS}
          classNamePrefix="react-select"
        />
      </div>

      <div className="leads-filters-field">
        <span className="leads-filters-label">Contact Info</span>
        <div className="leads-filters-checkbox-group">
          <label className="leads-filters-checkbox">
            <input type="checkbox" checked={filters['hasEmail']} onChange={handleCheck('hasEmail')} />
            Has Email
          </label>
          <label className="leads-filters-checkbox">
            <input type="checkbox" checked={filters['hasPhone']} onChange={handleCheck('hasPhone')} />
            Has Phone
          </label>
          <label className="leads-filters-checkbox">
            <input type="checkbox" checked={filters['hasLinkedin']} onChange={handleCheck('hasLinkedin')} />
            Has LinkedIn
          </label>
        </div>
      </div>

      <div className="leads-filters-actions">
        <button className="btn-style-new" style={{ width: '100%' }} onClick={onApply}>Apply Filters</button>
        <button className="btn-style-border" style={{ width: '100%' }} onClick={onClear}>Clear</button>
      </div>
    </div>
  );
};

export default LeadsFilters;

const INDUSTRY_OPTIONS = [
  { value: 'SaaS', label: 'SaaS' },
  { value: 'Technology', label: 'Technology' },
  { value: 'Healthcare', label: 'Healthcare' },
  { value: 'Finance', label: 'Finance' },
  { value: 'Real Estate', label: 'Real Estate' },
  { value: 'Manufacturing', label: 'Manufacturing' },
  { value: 'Retail', label: 'Retail' },
  { value: 'Education', label: 'Education' },
  { value: 'Marketing', label: 'Marketing' },
  { value: 'Consulting', label: 'Consulting' },
  { value: 'Legal', label: 'Legal' },
  { value: 'Insurance', label: 'Insurance' },
  { value: 'Logistics', label: 'Logistics' },
  { value: 'Media', label: 'Media' },
  { value: 'Non-Profit', label: 'Non-Profit' },
];

const COUNTRY_OPTIONS = [
  { value: 'United States', label: 'United States' },
  { value: 'United Kingdom', label: 'United Kingdom' },
  { value: 'Canada', label: 'Canada' },
  { value: 'Australia', label: 'Australia' },
  { value: 'Germany', label: 'Germany' },
  { value: 'France', label: 'France' },
  { value: 'India', label: 'India' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'Netherlands', label: 'Netherlands' },
  { value: 'Sweden', label: 'Sweden' },
];

const DEPARTMENT_OPTIONS = [
  { value: 'Sales', label: 'Sales' },
  { value: 'Marketing', label: 'Marketing' },
  { value: 'Engineering', label: 'Engineering' },
  { value: 'Operations', label: 'Operations' },
  { value: 'Finance', label: 'Finance' },
  { value: 'Human Resources', label: 'Human Resources' },
  { value: 'Product', label: 'Product' },
  { value: 'Executive', label: 'Executive' },
  { value: 'Customer Success', label: 'Customer Success' },
  { value: 'Legal', label: 'Legal' },
];

const EMPLOYEE_COUNT_OPTIONS = [
  { value: '1-10', label: '1–10' },
  { value: '11-50', label: '11–50' },
  { value: '51-200', label: '51–200' },
  { value: '201-500', label: '201–500' },
  { value: '501-1000', label: '501–1,000' },
  { value: '1001-5000', label: '1,001–5,000' },
  { value: '5001-', label: '5,000+' },
];
